import { Outlet } from 'react-router'
import { Header } from './components/Header'

export const BasicLayout = () => {
  return <>
    <Header />
    
    <Outlet />
  </>
}